<script setup lang="ts">
import ReloadPrompt from '@/components/ReloadPrompt.vue'
import FadeTransition from '@/components/FadeTransition.vue'
</script>

<template>
  <RouterView v-slot="{ Component, route }">
    <FadeTransition>
      <component :is="Component" :key="route.path" />
    </FadeTransition>
  </RouterView>
  <ReloadPrompt />
</template>
